<template>
  <PlatDataPanelUniformExam :custom-id="customId">
    <template #append="{batchId}">
      <ExamUniformScheduleAppend :key="batchId"
                                 :batch-id="batchId"></ExamUniformScheduleAppend>
    </template>
    <template #default="{batchId}">
      <template v-if="batchId">
        <keep-alive>
          <ExamUniformScheduleWrap :key="batchId"
                                   :batch-id="batchId"></ExamUniformScheduleWrap>
        </keep-alive>
      </template>
    </template>
  </PlatDataPanelUniformExam>
</template>

<script>
import PlatDataPanelUniformExam from '../../../wrapper/panel/PlatDataPanelUniformExam'
import ExamUniformScheduleAppend from './append'
import ExamUniformScheduleWrap from './wrap'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'ExamUniformSchedule',
  components: {
    PlatDataPanelUniformExam,
    ExamUniformScheduleAppend,
    ExamUniformScheduleWrap
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>
